/* unplugin-vue-components disabled */import { render } from "./sourcematerial.vue?vue&type=template&id=7645e85e&scoped=true"
import script from "./sourcematerial.vue?vue&type=script&lang=js"
export * from "./sourcematerial.vue?vue&type=script&lang=js"

import "./sourcematerial.vue?vue&type=style&index=0&id=7645e85e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7645e85e"]])

export default __exports__